export enum CONFIG_TYPES {
  DEFAULT = 'default',
  BRAND = 'brand',
  FORMAT = 'format'
}
